<template>
  <Progressbar v-if="loading && !meta.current_page" />
  <NetworkError v-else-if="errors" @tryAgain="getVideos()" />
  <div class="flex flex-col w-full h-full" v-else>
    <div class="alert bg-blue-custom-6 text-blue-custom-7">
      <span class="mx-auto">{{ __($route.params.type == 'education' ? 'Educational videos' : 'Application training')
        }}</span>
    </div>
    <div class="grid lg:grid-cols-5 md:grid-cols-2 gap-4 w-full mt-4" v-if="videos.length">
      <label v-for="item in videos" class="cursor-pointer video" for="video" @click="setVideo(item)">
        <div class="w-full relative h-full" v-if="item.method === 'direct_link'">
          <img :src="item.image" class="rounded-lg">
          <div class="romeo-embed-inner"><span class="romeo-embed-play"><svg viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <path
                  d="M7 6.134v11.732c0 .895 1.03 1.438 1.822.951l9.628-5.866c.733-.441.733-1.46 0-1.914L8.822 5.183C8.029 4.696 7 5.239 7 6.134z"
                  fill="#FBFBFC"></path>
              </svg></span></div>
        </div>
        <div v-html="item.embed_code" v-else class="rounded-lg overflow-hidden"></div>
      </label>
    </div>
    <NotFound v-else />
    <LoadMore v-if="meta.current_page < meta.last_page" :errors="errors" @tryAgain="getVideos(meta.current_page + 1)" />
  </div>
  <Teleport to="#app">
    <input type="checkbox" id="modal-video" class="modal-toggle" />
    <div class="modal">
      <div class="modal-box relative p-0" :class="{'max-w-3xl w-auto max-h-screen': video?.method == 'direct_link'}">
        <label for="modal-video" @click="video = null" class="btn btn-sm btn-circle absolute left-2 top-2 z-50">✕</label>
        <video class="max-h-[90vh] w-auto h-auto max-w-full object-contain mx-auto" controls
          v-if="video?.method === 'direct_link'" :poster="video?.image">
          <source :src="`${video?.embed_code}#t=0.1`" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div v-html="video?.embed_code" v-else></div>
      </div>
    </div>
  </Teleport>
</template>
<script setup>

import { onMounted, onUpdated, reactive } from "vue";
import useVideo from "../../../composables/shop/video";

const { videos, video, getVideos, loading, meta, errors, route } = useVideo();
const setVideo = (item) => video.value = item;
onMounted(() => {
  getVideos();
  document.querySelector('.drawer-content').addEventListener('scroll', (e) => {
    const scrollbar = e.target;
    if (meta.current_page < meta.last_page && !loading.value && !errors.value && (scrollbar.scrollTop + scrollbar.offsetHeight) >= (scrollbar.scrollHeight - 8)) {
      getVideos(meta.current_page + 1);
    }
  });
});
</script>